__turbopack_context__.v({
  "appIcon": "rLgOua_appIcon",
  "cardHeader": "rLgOua_cardHeader",
  "cardTitle": "rLgOua_cardTitle",
  "description": "rLgOua_description",
  "desktopCard": "rLgOua_desktopCard",
  "dismissButton": "rLgOua_dismissButton",
  "downloadCta": "rLgOua_downloadCta",
  "minimiseButton": "rLgOua_minimiseButton",
  "mobileBanner": "rLgOua_mobileBanner",
  "mobileText": "rLgOua_mobileText",
  "panel": "rLgOua_panel",
  "qrBox": "rLgOua_qrBox",
  "root": "rLgOua_root",
  "trigger": "rLgOua_trigger",
  "triggerLabel": "rLgOua_triggerLabel",
});
